<template>

  <div class="img_vueCropper">
    <el-upload class="avatar-uploader" drag action="" :show-file-list="false" :on-change="handlePreview"
      :auto-upload="false" accept="image/*">
      <div class="el-upload__text" v-if="!logo">将文件拖到此处，或<em>点击上传</em></div>
      <el-image v-if="logo" :src="logo">
        <div slot="error" class="image-slot">
          <img style="width: 100%;height: 100%;"
            src="https://site.wei.raytonecn.com/server/public/static/images/icon.png" alt="">
        </div>
      </el-image>
      <i v-else class="el-icon-plus avatar-uploader-icon" style="padding:64px"></i>
    </el-upload>
    <el-button type="primary" v-if="logo" @click="img_upload">确认上传图片</el-button>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog v-dialogDrag title="图片剪裁" :visible.sync="dialogVisible" :close-on-click-modal='false' append-to-body
      style="margin-top: -110px !important;">
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper ref="cropper" v-if="dialogVisible" :img="option.img" :outputSize="option.size"
            :outputType="option.outputType" :info="true" :full="option.full" :canMove="option.canMove"
            :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop"
            :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
            :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" :high="option.high"
            :maxImgSize='option.maxImgSize' :mode='option.mode' :infoTrue="option.infoTrue" :fixedBox="option.fixedBox">
          </vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="img_bili(3)" icon='el-icon-refresh-right'>旋转</el-button>
        <el-button @click="dialogVisible = false;">不裁剪</el-button>
        <el-button @click="img_bili(1)">图片比例：1:1</el-button>
        <el-button @click="img_bili(0)">图片比例：3:4</el-button>
        <el-button @click="dialogVisible = false;logo=''">取 消</el-button>
        <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import waves from "../directive/waves";
  import {VueCropper} from "vue-cropper";
  import {UploadPic} from "../../../api/abbNewApi.js";
  import axios from "axios";
  // import defaultSettings from '@/settings'
  export default {
    name: "ComplexTable",
    directives: {waves},
    components: {VueCropper},
    data () {
      return {
        logo: '',
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: '', // 裁剪图片的地址
          info: true, // 裁剪框的大小信息
          outputSize: 0.7, // 裁剪生成图片的质量
          outputType: 'png', // 裁剪生成图片的格式
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 300, // 默认生成截图框宽度
          autoCropHeight: 300, // 默认生成截图框高度
          fixedBox: false, // 固定截图框大小 不允许改变
          fixed: false, // 是否开启截图框宽高固定比例
          fixedNumber: [1,1], // 截图框的宽高比例
          full: false, // 是否输出原图比例的截图
          canMoveBox: true, // 截图框能否拖动
          maxImgSize: 'max',
          mode: "100px",
          high: true, // 截图框能否拖动
          original: true, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        file: '',  //上传文件
        // 防止重复提交
        loading: false,
        flag: false,
        fileName: '',
        imgPath: '',
        imgInfo: {},
        maxSize: 1000,//图片最大宽高
      }
    },
    mounted () {
      // http://47.112.166.12:5000
      //this.imgPath = axios.defaults.baseURL;
      //   this.imgPath = defaultSettings.downLoadUrl;
      this.imgPath="http://47.112.166.12:5000";
    },
    methods: {
      img_upload () {
        this.loading=true;
        // 获取截图的blob数据
        var vue=this;

        this.dealImage(this.logo,this.imgInfo,function(base) {
          var filet=vue.dataURLtoFile(base,vue.fileName);
          // var formData = new FormData();
          // formData.append("filePath", filet, vue.fileName);
          // formData.append("name", 'file');
          let formData={
            "file": filet
          };
          // console.log("图片上传",base);
          vue.$emit('func',base)
          //    vue.$emit('func', vue.imgPath + res.data.downLoadUrl)

        });
      },
      img_bili (v) {
        if(v===3) {
          this.$refs.cropper.rotateRight()
          return
        }

        if(v) {
          this.$set(this.option,'fixedNumber',[1,1])
        } else {
          this.$set(this.option,'fixedNumber',[3,4])
        }
        setTimeout(() => {
          this.$refs.cropper.goAutoCrop()
        },100);
      },
      //多图上传之前判断类型
      beforeUpload (file) {
        const isLt5M=file.size/1024/1024<5
        if(!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!')
          return false
        }

        this.file=file.raw;
        this.fileName=file.name;
        // .jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF
        var b=file.type.name(".");
        if(b[0]!="image") {
          this.$message({
            showClose: true,
            type: "warning",
            message: "必须上传图片格式"
          });
          return false;
        }
      },
      handlePreview (file) {
        const isLt5M=file.size/1024/1024<5
        if(!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!')
          return false
        }
        this.fileName=file.name;
        this.file=file.raw;
        // .jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF
        var b=file.raw.type.split("/");
        if(b[0]!="image") {
          this.$message({
            showClose: true,
            type: "warning",
            message: "必须上传图片格式"
          });
          return false;
        }
        this.logo=URL.createObjectURL(file.raw);
        var img=new Image()
        img.src=this.logo
        var vm=this
        img.onload=function() {
          vm.$set(vm.imgInfo,'width',img.width)
          vm.$set(vm.imgInfo,'height',img.height);
        }
        this.$set(this.option,'img',this.logo)
        this.dialogVisible=true;
        this.flag=true;
        this.loading=false;
        var d=setInterval(() => {
          this.$refs.cropper.changeScale(-2)
        },1);
        setTimeout(() => {
          clearInterval(d)
        },1000);
      },
      // 上传按钮   限制图片大小
      changeUpload (file,fileList) {
        const isLt5M=file.size/1024/1024<5
        if(!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!')
          return false
        }
        this.fileinfo=file

        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(() => {
          this.option.img=file.url
          this.dialogVisible=true;
        })
      },
      // 原图不裁剪
      submit (v) {
        var d=this.logo;
        this.dialogVisible=false;
      },

      /** 图片压缩 返回base64 */
      dealImage (path,obj,callback) {
        var img=new Image();
        img.src=path;
        var vue=this
        img.onload=function() {
          var that=this;
          // 默认按比例压缩
          var w=that.width,
            h=that.height,
            scale=w/h;
          w=obj.width||w;
          h=obj.height||(w/scale);
          if(w>vue.maxSize) {
            h=h/(w/vue.maxSize);
            w=vue.maxSize;
          }
          if(h>vue.maxSize) {
            w=w/(h/vue.maxSize);
            h=vue.maxSize;
          }
          var quality=1;  // 默认图片质量为0.9
          //生成canvas
          var canvas=document.createElement('canvas');
          var ctx=canvas.getContext('2d');
          // 创建属性节点
          var anw=document.createAttribute("width");
          anw.nodeValue=w;
          var anh=document.createAttribute("height");
          anh.nodeValue=h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(that,0,0,w,h);
          // 图像质量
          if(obj.quality&&obj.quality<=1&&obj.quality>0) {
            quality=obj.quality;
          }
          // quality值越小，所绘制出的图像越模糊
          var base64=canvas.toDataURL('image/jpeg',quality);
          // 回调函数返回base64的值
          callback(base64);
        }
      },
      /** base64转file
 * filename图片的名字，dataurl是base64地址
 */
      dataURLtoFile (dataurl,filename) {
        var arr=dataurl.split(','),mime=arr[0].match(/:(.*?);/)[1],
          bstr=atob(arr[1]),n=bstr.length,u8arr=new Uint8Array(n);
        while(n--) {
          u8arr[n]=bstr.charCodeAt(n);
        }
        return new File([u8arr],filename,{type: mime});
      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish () {
        this.$refs.cropper.getCropBlob((data) => {
          this.file=data;
        })
        this.loading=true
        this.flag=false;
        this.$refs.cropper.getCropData((data) => {
          this.dialogVisible=false;
          this.$set(this,'logo',data);
          let img=new Image()
          img.src=data;

          const vm=this
          img.onload=function() {
            vm.$set(vm.imgInfo,'width',img.width)
            vm.$set(vm.imgInfo,'height',img.height)
          }
          this.loading=false;
        })
      }
    }
  };
</script>
<style>
  .filter-container .el-upload-list {
    display: none !important;
  }

  .el-image__inner {
    object-fit: contain;
  }

  .img_vueCropper .el-upload-dragger {
    min-width: 180px !important;
    height: auto;
  }

  .crop-info {
    left: 100% !important;
  }
</style>

<style lang="scss" scoped>
  .img_vueCropper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 15px;
  }

  .cropper-content {
    .cropper {
      width: auto;
      height: 500px;
    }
  }

  .el-upload-dragger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: auto !important;
  }
</style>